import md5 from 'md5'
import qs from 'query-string';
import moment from 'moment';
import {IArticle, ICategories} from "../types/IArticle";
import {IComet, ICometList, COMET_MESSAGE_TYPE} from "../types/IComet";
import {API_KEY_RESCALER, CDN_IMAGE_DOMAIN, COLORS_GRAPH, FEED_END_DATE, SIDS_RTL, THEME_STYLED} from "../constants";
import {IMedia, IMediaVariant, MEDIA_VARIANT} from "../types/IMedia";
import {IFloor} from "../types/IFloor";
import {IAnalyticsData} from "../store/reducers/AnalyticsSlice";
import {ISid, LANG, THEME} from "../types/IUser";
import {IHistory} from "../types/IHistory";
import { DROPDOWN_PLACEMENT } from '../component/Dropdown/DropdownMenu'
import favicon from '../assets/favicon/favicon.ico';
import faviconSputnik from '../assets/favicon/favicon_sputnik.ico';

export const DATE_KEYS = 'YYYYMMDD';
export const DATE_FORMAT  = 'DD.MM.YYYY';
export const DATE_FORMAT_SHORT  = 'DD.MM.YY';
export const TIME_FORMAT  = 'HH:mm';
export const DATE_TIME_FORMAT = DATE_FORMAT + ' ' + TIME_FORMAT;
export const START_DATE_RANGE = '00:00';
export const END_DATE_RANGE = '23:59';

export const gutter = (index: number, direction: string) => {
    const gutter = document.createElement('div');
    const i1 = document.createElement('i');
    const i2 = document.createElement('i');
    const i3 = document.createElement('i');
    const i4 = document.createElement('i');

    gutter.appendChild(i1);
    gutter.appendChild(i2);
    gutter.appendChild(i3);
    gutter.appendChild(i4);
    gutter.className = `gutter gutter-${direction}`;
    return gutter
};

export const disabledScroll = () => {
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100%';
    document.body.setAttribute('scroll', 'false');
};

export const enabledScroll = () => {
    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.setAttribute('scroll', '');
};

export const dateListFormat = (date: string | Date) => {
  return moment(date).format('HH:mm')
};

export const dateFormat = (date: string | Date) => {
    const now = moment(),
        diffDay = now.diff(moment(date).format('YYYY-MM-DD'), 'days'),
        sameYear = now.isSame(moment(date).format('YYYY-MM-DD'), 'year')

    if(diffDay === 0) { return moment(date).format('HH:mm') }
    // if(diffDay === 1) { return '[' + getMsg({id: "app.fUserLog.header.time", values:{ type: "yesterday"}}) +',] HH:mm' }
    if(sameYear === true) { return moment(date).format('DD MMM') }

    return moment(date).format('DD.MM.YY')
};

export const getMinutesUntil = (past: number | null) => {
    const now = moment().unix(); // Получаем текущее время в формате Unix time

    const replaceText = (txt: string) => {
        return txt?.replaceAll('минута', 'минуту')
    }

    if(!past || (past - now < 0)){
        return 0
    }

    const diffInSeconds = past - now; // Разница во времени в секундах
    const duration = moment.duration(diffInSeconds, 'seconds'); // Создаем длительность из разницы

    return replaceText(duration.humanize()); // Возвращаем форматированную строку с учётом локализации
}

export const getDate = () => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};

export const getDateSubtractDays = (days: number) => {
    const d = moment().subtract(days, 'days').toDate();

    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};

export const validDate = (date: string, format: string = DATE_FORMAT) => {
    return moment(date, format).isValid() && date.replace(/_/gi,'').length === format.length;
};

export const validTime = (time: string, format: string = TIME_FORMAT) => {
    return moment(time, format).isValid() && time.replace(/_/gi,'').length === format.length;
};

export const serialize = (data: object | any) => {
    let newData = {...data};

    (Object.keys(newData) as Array<keyof typeof newData>).map(name => {
       if(newData[name] === undefined || newData[name] === null || newData[name] === '' || name === 'label' || name === 'startTime' || name === 'endTime'){
           delete newData[name]
       }
       if((name === 'match' || name === 'title' || name === 'body' || name === 'keywords') && data?.['query'] === ''){
           delete newData[name]
       }
       if(Array.isArray(newData[name])){
           (newData[name] as any[]) = (newData[name] as any[]).filter(item => item);
       }
       if((newData[name] as any) instanceof Date || ((name === 'date_start' || name === 'date_end') && newData[name])){
           let format = (moment(data[name]).get('hour') || moment(data[name]).get('minute')) ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY';

           (newData[name] as string) = moment(data[name]).format(format);
       }
    });

    return newData
};

export const skipParams = (data: object | any, skip: string[]) => {
    let newData = serialize(data);

    (Object.keys(newData) as Array<keyof typeof newData>).map((name: any) => {
        if(name === 'offset' || name === 'limit' || skip.includes(name)){
            delete newData[name]
        }
    });
    return newData
};

export const objectToArray = (data: object) => {
    const arr: number[][] = [];

    (Object.keys(data) as Array<keyof typeof data>).map(name => {
        arr.push(data[name])
    });

    return arr.length ? arr.flat(1) : [];
};

export const filterFeeds = (data: object) => {
    const arr: string[] = [];

    (Object.keys(data) as Array<keyof typeof data>).map(name => {
        if((data[name] as any)?.td === FEED_END_DATE){
            arr.push(name)
        }
    });

    return arr
};

export const convertToState = (data: any) => {
    let newData = {...data};

    (Object.keys(newData) as Array<keyof typeof newData>).map(name => {
        if(typeof newData[name] === 'string' && (name === 'date_start' || name === 'date_end')){
            if(newData[name].length === DATE_FORMAT.length){
                newData[name] = moment(newData[name], DATE_FORMAT).toDate()
            } else if(newData[name].length === DATE_TIME_FORMAT.length){
                newData[name] = moment(newData[name], DATE_TIME_FORMAT).toDate()
            } else{
                newData[name] = moment(newData[name]).toDate()
            }
        }
    });

    return newData
};


export const sortedArticles = (data: IArticle[]) => {
    if(!data || !data.length) return {};

    return data.sort((a, b) => {
            const aDate = moment(a.article_date, 'YYYY-MM-DD HH:mm:ss').unix();
            const bDate = moment(b.article_date, 'YYYY-MM-DD HH:mm:ss').unix();
            return bDate - aDate;
        }).reduce<Record<string, IArticle[]>>((accumulator, currentValue) => {
        const key: string = moment(currentValue.article_date).format('YYYYMMDD');
        const value: IArticle[] = accumulator[key] ? accumulator[key].concat(currentValue) : ([] as IArticle[]).concat(currentValue);

        return {...accumulator, ...{[key]: value}}
    }, {});
};


export const arrayCompare = (array1: any, array2: any) => {
    if(!Array.isArray(array1) || !Array.isArray(array2)){
        return false
    }
    return array1.length === array2.length && array1.every(value => array2.includes(value))
};

export const arrayCompareSome = (array1: any, array2: any) => {
    if(!Array.isArray(array1) || !Array.isArray(array2)){
        return false
    }

    return array1.some(value => array2.includes(value))
};

export const arrayCompareEvery = (array1: any, array2: any) => {
    if(!Array.isArray(array1) || !Array.isArray(array2)){
        return false
    }

    return array1.every(value => array2.includes(value))
};

export const arrayCompareElement = (array1: any, array2: any) => {
    if(!Array.isArray(array1) || !Array.isArray(array2)){
        return false
    }
    return array1.length === array2.length && array1.every((value, index) => value === array2[index])
};

export const arrayCompareCheckbox = (array1: any, array2: any) => {
    if((!Array.isArray(array1) || !Array.isArray(array2)) || (!array1.length || !array2.length)){
        return false
    }
    return arrayCompare(getUnique(array1), getUnique(array2)) || null
};



export const arrayCompareSomeCheckbox = (array1: any, array2: any) => {
    if(!Array.isArray(array1) || !Array.isArray(array2)){
        return false
    }

    if(array2.every(value => array1.includes(value))){
       return true
    }
    if(array2.some(value => array1.includes(value))){
        return null
    }
    return false
};


export const arrayExcludeIds = (array1: number[], array2: number[]) => {
    return array1.filter(item => !array2.includes(item)) || []
};

export const arrayEqualIds = (array1: number[], array2: number[]) => {
    return array1.filter(item => array2.includes(item)) || []
};


export const toArray = (data: any) => {
    if(!data){
        return []
    }
    if(!Array.isArray(data)){
        return [data]
    }
    return data
};

export const getUnique = (arr: any[]) => {
    return arr.filter((value, index, self) => self.indexOf(value) === index)
};

export const unique = (array: any[], propertyName: string) => {
    return array.filter((e, i) => array.findIndex(a => a[propertyName] === e[propertyName]) === i);
};

export const getKeywords = (keywords: string | undefined) => {
    if(!keywords){
        return []
    }
    if(keywords.indexOf('*') > -1){
        return keywords.split('*')?.filter(item => item.trim());
    }
    return keywords.split(',')?.filter(item => item.trim()) || [];
};

export const download = (path: string, filename : string) => {
    // form a new link
    const anchor = document.createElement('a');
    anchor.href = path;
    anchor.download = filename;

    // Append to the DOM
    document.body.appendChild(anchor);

    // Trigger `click` event
    anchor.click();

    // Remove element from DOM
    document.body.removeChild(anchor);
};

export const convertCometData = (data: IComet[], sids: ISid[]) => {
    let convert = {
        articles: [],
        logout: null,
        subscriptions_expired: null
    } as ({articles: IArticle[], logout: null | boolean, subscriptions_expired: null | boolean});
    let externalSids: string[] = sids.filter(sid => sid.list_is_internal === 0).map(sid => sid.sid);

    for (let i = 0; i < data.length; i++){
        if(data[i].message_type === COMET_MESSAGE_TYPE.ARTICLE){
            const date = data[i].article.date;
            const format = date.year + '-' + date.month + '-' + date.day + ' ' + date.hour + ':' + date.min + ':' + date.sec + '+03';
            const categories = data[i].article.list.reduce((accumulator: ICategories[], currentValue: ICometList) => {
                return accumulator.concat({
                    list_sid: currentValue.sid,
                    list_title: currentValue.title,
                    list_is_internal: externalSids.includes(currentValue.sid) ? 0 : 1
                })
            },[]);

            convert.articles.push({
                article_id: data[i].article.id,
                article_priority: data[i].article.priority || 3,
                article_title: data[i].article.title,
                article_read: data[i].article.article_read || 0,
                article_keywords: data[i].article.keywords || '',
                article_lead:  data[i].article.lead,
                article_date: format,
                article_body: data[i].article.lead,
                categories: categories
            })
        } else if(data[i].message_type === COMET_MESSAGE_TYPE.LOGOUT){
            convert.logout = true
        } else if(data[i].message_type === COMET_MESSAGE_TYPE.SUBSCRIPTIONS_EXPIRED){
            convert.subscriptions_expired = true
        }
    }

    return convert
};

export const containsSids = (articles: IArticle[], sids: string[]) => {
    return articles.filter(article => article.categories.map(list => list.list_sid).some(item => sids.includes(item))) || [];
};

export const getScrollParent: any = (node: any) => {
    if (node === null) {
        return null;
    }

    if (node.tagName === 'BODY') {
        return document
    } else if((window.getComputedStyle(node).overflow === 'scroll' || window.getComputedStyle(node).overflow === 'auto')
        && node.scrollHeight > node.clientHeight){
        return node;
    } else if(node.parentNode) {
        return getScrollParent(node.parentNode);
    } else {
        return null
    }
};

export const getPlacement = (refAnchor: HTMLDivElement | null, refDropdown: HTMLDivElement | null, {placement = DROPDOWN_PLACEMENT.AUTO, offsetX = 0, offsetY = 0, rtl = false}): {x: number, y: number} => {
    if(!refAnchor || !refDropdown){
        return {
            x: 0,
            y: 0
        }
    }

    const header = refAnchor.getBoundingClientRect();
    const content = refDropdown.getBoundingClientRect();
    const windowY = window.innerHeight;
    const windowX = window.innerWidth;
    // const top = windowY < (header.top + header.height + content.height + offsetY) ? header.top + header.height - offsetY: header.top - content.height - offsetY;
    const top = header.top < content.height - offsetY ? header.top + header.height + offsetY : header.top - content.height - offsetY;
    const bottom = windowY < (header.top + header.height + content.height + offsetY) ? header.top - content.height - offsetY: header.top + header.height - offsetY;
    const right = header.left + header.width - content.width - offsetX;
    const left = windowX < (header.left + content.width) ? windowX  - content.width : header.left - offsetX;
    const center = header.left + header.width / 2 - content.width / 2;

    if(placement === DROPDOWN_PLACEMENT.AUTO && rtl){
        return {
            x: right,
            y: bottom,
        }
    } else if(placement === DROPDOWN_PLACEMENT.AUTO){
        return {
            x: left,
            y: bottom
        }
    } else if((placement === DROPDOWN_PLACEMENT.LEFT && !rtl) || (placement === DROPDOWN_PLACEMENT.RIGHT_BOTTOM && rtl)){
        return {
            x: left,
            y: bottom,
        }
    } else if((placement === DROPDOWN_PLACEMENT.LEFT_TOP && !rtl) || (placement === DROPDOWN_PLACEMENT.RIGHT_TOP && rtl)){
        return {
            x: left,
            y: top - 6,
        }
    } else if((placement === DROPDOWN_PLACEMENT.RIGHT_TOP && !rtl) || (placement === DROPDOWN_PLACEMENT.LEFT_TOP && rtl)){
        return {
            x: right,
            y: top,
        }
    } else if((placement === DROPDOWN_PLACEMENT.RIGHT_BOTTOM && !rtl) || (placement === DROPDOWN_PLACEMENT.LEFT && rtl)){
        return {
            x: right,
            y: bottom,
        }
    } else if((placement === DROPDOWN_PLACEMENT.CENTER_BOTTOM)){
        return {
            x: center,
            y: bottom,
        }
    } else if((placement === DROPDOWN_PLACEMENT.CENTER_TOP)){
        return {
            x: center,
            y: top,
        }
    }

    return {
        x: 0,
        y: 0
    }
};


/**
 * @param {date|moment} start The start date
 * @param {date|moment} end The end date
 * @param {string} type The range type. eg: 'days', 'hours' etc
 */

export const getMomentRange = (startDate: Date | moment.Moment, endDate: Date | moment.Moment, type: any) => {
    let fromDate = moment(startDate);
    let toDate = moment(endDate);
    let diff = toDate.diff(fromDate, type);
    let range = [];
    for (let i = 0; i <= diff; i++) {
        range.push(moment(startDate).add(i, type));
    }
    return range
};


export const dateToString = (date: Date | moment.Moment | null | undefined | string, format: string = DATE_FORMAT): string => {
    if(typeof date === "string"){
       return date
    } else if(!date) {
        return ''
    }else if(moment(date, format).isValid()){
        return moment(date).format(format)
    }

    return ''
};

export const getPlayerTime = (seconds: number) => {
    const pad = (number: number) => {
        return ('0' + number).slice(-2)
    };

    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours();
    const mm = date.getUTCMinutes();
    const ss = pad(date.getUTCSeconds());
    if (hh) {
        return `${hh}:${pad(mm)}:${ss}`
    }
    return `${mm}:${ss}`
};

export const copy = (text: string) => {
    const textField = document.createElement('textarea');
    textField.value = text.replace(/<\/?[^>]+>/g, '').replace(/&nbsp;/gi, " ");
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
};

export const copyArticle = (articles: IArticle[]) => {
    let text = '';
    for(let i = 0; i < articles.length; i ++){
        text += moment(articles[i].article_date).format(DATE_TIME_FORMAT) + '\n' + articles[i].article_title + '\n' + articles[i].article_body;
    }
    const textField = document.createElement('textarea');
    textField.value = text.replace(/<p>/g, '\n\n').replace(/<\/?[^>]+>/g, '').replace(/&nbsp;/gi, " ");
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
};

export const copyHistory = (history: IHistory[]) => {
    let text = '';

    for(let i = 0; i < history.length; i ++){
        text +=  history[i].article_id + '\n' + moment(history[i].date).format(DATE_TIME_FORMAT) + '\n' + history[i].article_title;
    }
    const textField = document.createElement('textarea');
    textField.value = text.replace(/<\/?[^>]+>/g, '').replace(/&nbsp;/gi, " ");
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
};


export const printTranslate = (translate: object): string[] => {
    return (Object.keys(translate as Array<keyof typeof translate>).map((key) => {
        const level = translate[key as keyof typeof translate];
        if(typeof level === "string"){
            return level
        } else {
            return printTranslate(level)
        }
    })).flat();
};

export const diff = (obj1: any, obj2: any, keys: string[] | null = null) => {
    const objectKeys: string[] = keys || Object.keys(obj1);

    return objectKeys.map(name => {
        if(Array.isArray(obj1[name]) && Array.isArray(obj2[name])){
            return !arrayCompare(obj1[name], obj2[name]) ? name : null
        } else if(obj1[name] !== obj2[name]){
            return name
        }

        return null
    }).filter(item => item);
};

const getSize = (variant: IMediaVariant, cropWidth: number = 0, cropHidth: number = 0) => {
    const cropInfo = variant["media_variant_meta_data"]?.crop_info || null,
        ratio = ((parseInt(cropInfo?.y2 || '0') - parseInt(cropInfo?.y1 || '0'))/(parseInt(cropInfo?.x2 || '0') - parseInt(cropInfo?.x1 || '0'))) || 1,
        width = cropWidth || (parseInt(cropInfo?.x2 || '0') - parseInt(cropInfo?.x1 || '0')),
        height = cropHidth || width * ratio;

    return {
        imageWidth: width,
        imageHeight: height
    }

};

export const getMediaSrc = (media: IMedia, variants: MEDIA_VARIANT[] = [MEDIA_VARIANT.AR16x9], width: number = 0, height: number = 0, compression: number = 80, watermark: number = 0, isAdaptive: number = 1) => {
    const variant = variants.map(v => media.media_variants.find(item => item.media_variant_type === v)).filter(e => e)[0],
        hires = media.media_variants.find(item => item.media_variant_type === MEDIA_VARIANT.HIRES);

    if(variant && hires && hires["media_variant_filename"] && variant["media_variant_meta_data"]) {
        const filename = hires["media_variant_filename"].replace(/\..*$/, ''),
            hiresExt = hires["media_variant_filename"].match(/\.(.*)/)?.[1],
            cropInfo = variant["media_variant_meta_data"]?.crop_info || null,
            x1 = cropInfo?.x1 || 0,
            y1 = cropInfo?.y1 || 0,
            x2 = cropInfo?.x2 || 0,
            y2 = cropInfo?.y2 || 0,
            coordinates = `${x1}:${y1}:${x2}:${y2}`,
            size = `${width || '0'}x${height || '0'}`,
            salt = md5(`${filename}_${coordinates}_${size}_${compression}_${watermark}_${isAdaptive}_${API_KEY_RESCALER}.${hiresExt}`),
            url = `${filename}_${coordinates}_${size}_${compression}_${watermark}_${isAdaptive}_${salt}.${hiresExt}`;

        return {
            src: CDN_IMAGE_DOMAIN + url + '?projectName=terminal',
            ...getSize(variant, width, height)
        }
    }

    return {
        src: '',
        imageWidth: 0,
        imageHeight: 0
    }
};

export const getMediaTitle = (media: IMedia) => {
    return media.media_title
};


export const getMaterial = (floors: IFloor[] | null | undefined ) => {
    if(!floors){
        return null
    }

    const block = floors.map(floor => floor.block.find(block => block.type === 'material')) || null;

    if(!block){
        return null
    }

    const material = block[0]?.position[0]?.article[0] || null

    return material
};

export const isMobile = () => {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||(window as any).opera);
    return check;
};

export const declOfNum = (number: number, words: [string, string, string]) => {
    const cases = [2, 0, 1, 1, 1, 2];
    return words[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
}

export const round = (number: number) => {
    return number > 100 ? '+99' : number
};

export const pagination = (page: number, maxPage: number, delta: number) => {
    let current = page,
        last = maxPage,
        left = current - delta,
        right = current + delta + 1,
        range = [],
        rangeWithDots = [],
        l;

    for (let i = 1; i <= last; i++) {
        if (i === 1 || i === last || i >= left && i < right) {
            range.push(i);
        }
    }

    for (let i of range) {
        if (l) {
            if (i - l === 2) {
                rangeWithDots.push(l + 1);
            } else if (i - l !== 1) {
                rangeWithDots.push('...');
            }
        }
        rangeWithDots.push(i);
        l = i;
    }

    return rangeWithDots;
};

export const getGraphLabels = (data: IAnalyticsData[]) => {
    if(!data.length){
        return []
    }
    return data.map(item => moment(item.value).format('DD MMM'))
};

export const getGraphCount = (data: IAnalyticsData[], sids: string[]) => {
    if(!data.length){
        return []
    }

    return data.map(item =>
            item.pivot.filter(pivot => sids.includes(pivot.value)).length
                ? item.pivot.filter(pivot => sids.includes(pivot.value)).reduce((a,b) => a + b?.count, 0)
                : 0
            ) || []
};

export const getGraphCountAll = (data: IAnalyticsData[], AllSids: ISid[]) => {
    if(!data.length){
        return []
    }

    return data.map(count => count.count) || []
};


export const getGraph = (data: IAnalyticsData[], sids: {data: ISid, color: string}[], AllSids: ISid[], label: string) => {
    const labels = getGraphLabels(data);

    if(sids.length){
        return {
            labels,
            datasets: sids.map(sid => {
                return {
                    label: sid.data.title,
                    data: getGraphCount(data, [sid.data.sid]),
                    borderColor: sid.color,
                    backgroundColor: sid.color
                }
            })
        }
    } else {
        return {
            labels,
            datasets: [{
                label: label,
                data: getGraphCount(data, AllSids.map(item => item.sid)),
                borderColor: "#44579E",
                backgroundColor: "#44579E"
            }]
        }
    }
};

export const getGraphSids = (data: IAnalyticsData[]): string[] => {
    if(!data.length){
        return []
    }

    return data[0]?.pivot?.map(item => item.value) || []
};

export const getGraphColor = (count: number) => {
    const l = COLORS_GRAPH.length;
    const n = count - Math.floor(count/l) * l;

    return COLORS_GRAPH[n];
};

export const getNextGraphColor = (color: string | undefined) => {
    if(color === undefined){
        return COLORS_GRAPH[0];
    }

    const index = COLORS_GRAPH.indexOf(color) || 0;

    return getGraphColor(index + 1);
};

export const getCookie = (name: string) => {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export const setCookie = (cookieName: string, value: string, msToExpire: number, path: string, domain?: string, secure?: string) => {
    let expiryDate;

    if (msToExpire) {
        expiryDate = new Date();
        expiryDate.setTime(expiryDate.getTime() + msToExpire);
    }

    document.cookie = cookieName + '=' + value +
        (msToExpire ? ';expires=' + (expiryDate as any).toGMTString() : '') +
        ';path=' + (path || '/') +
        (domain ? ';domain=' + domain : '') +
        (secure ? ';secure' : '');
}

export const removeCookie = (cookieName: string) => {
    document.cookie = cookieName + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
}


export const searchParams = (filter: object | any, skip: string[] = []) => {
    if(filter?.id){
        return qs.stringify(skipParams({id: filter.id, parentId: filter.parentId}, skip), {skipNull: true, skipEmptyString: true, arrayFormat: 'bracket'});
    } else if(filter?.ids && filter?.ids.length){
        return qs.stringify(skipParams({ids: filter.ids, name: filter.name}, skip), {skipNull: true, skipEmptyString: true, arrayFormat: 'bracket'});
    } else {
        return qs.stringify(skipParams(filter, skip), {skipNull: true, skipEmptyString: true, arrayFormat: 'bracket'});
    }
};

export const setSearchParams = (filter: object | any) => {
    const search = searchParams(filter);
    const url = window.location.origin;

    window.history.replaceState({}, '' , url + '?' + search);
};

export const getSearchParams = () => {
    const params = qs.parse(window.location.search, {arrayFormat: 'bracket'});
    const kyes = ['date_start', 'date_end', 'sid_list', 'case_sensitive', 'media_type', 'fields', 'stopwords', 'query', 'match', 'priority', 'id', 'parentId', 'name', 'ids', 'priority'];

    (Object.keys(params) as Array<keyof typeof params>).map((name: any) => {
       if(!kyes.includes(name)){
           delete params[name]
       }
       if((name === 'date_start' || name === 'date_end') && moment(params[name] as any, DATE_TIME_FORMAT).isValid()){
           (params[name] as any) = moment(params[name] as any, DATE_TIME_FORMAT).toDate();
       }
       if(name === 'case_sensitive'){
            (params[name] as any) = parseInt(params[name] as any)
       }
       if(name === 'priority' && Array.isArray(params[name])){
            (params[name] as any) = (params[name] as any).map((i: any) => parseInt(i))
       }
       if((name === 'sid_list' || name === 'media_type' || name === 'fields' || name === 'priority') && !Array.isArray(params[name])){
           delete params[name]
       }
    });

    if(params){
        return params
    }
    return {}
};

export const changeRtl = (rtl: boolean) => {
    const html = document.querySelectorAll('html')[0];
    html.setAttribute('dir', rtl ? 'rtl' : 'ltr');
};

export const changeFavicon = (theme: THEME) => {
    let link = document.querySelectorAll("link[rel~='icon']")?.[0];

    if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'icon');
        document.head.appendChild(link);
    }

    if(THEME.SPUNTIK === theme){
        link.setAttribute('href', faviconSputnik);
    } else{
        link.setAttribute('href', favicon);
    }
};

export const changeTheme = (theme: THEME) => {
    const styled = THEME_STYLED[theme];

    changeFavicon(theme);
    (Object.keys(styled) as Array<keyof typeof styled>).forEach(prop => {
        document.documentElement.style.setProperty(prop, styled[prop]);
    });
};

export const objValues = (data: object) => {
    return Object.values(data)
};

export const objKeys = (data: object) => {
    return Object.keys(data)
};

export const merge = (initial: object, diff: object) => {
    const obj = {...initial};
    (Object.keys(diff) as Array<keyof typeof diff>).forEach(name => {
        obj[name] = diff[name];
    })
};

export const isRussian = (str:string) => {
    let text = str.replace(/[`1-9~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/\s]/gi, '');
    let reg = new RegExp('[а-яА-Я]');
    let check = true;

    for (let i = 0; i < text.length; i++) {
        if(!reg.test(text[i])){
            check = false;
            break;
        }
    }

    return check
};

export const isArticleRtl = (article: IArticle | undefined) => {
    if(!article){
        return false
    }
    const sids = article.categories.map(item => item.list_sid);

    return sids.some(sid => SIDS_RTL.includes(sid));
};